@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-dropdown'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

<p-multiSelect
    [inputId]="id() + '-dropdown'"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [optionDisabled]="optionDisabled()"
    [appendTo]="appendTo()"
    [showClear]="value() && value().length > 0"
    [placeholder]="placeholder() | translate"
    [options]="options()"
    [filterBy]="filterBy()"
    [display]="'chip'"
    [filter]="filter()"
    [disabled]="disabled()"
    [(ngModel)]="value"
    [fluid]="true"
    [maxSelectedLabels]="10"
    [size]="size()"
    (onChange)="value.set(value())"
    (onClear)="onClear.emit()"
    (onPanelHide)="onHide.emit()"
    (onFocus)="onFocus.emit()">
    <ng-template #item let-user>
        <div class="user-item">
            <p class="user-name">
                {{ user[optionLabel()] }}
            </p>
            <p class="user-email">
                {{ user.email }}
            </p>
        </div>
    </ng-template>
</p-multiSelect>
